// extracted by mini-css-extract-plugin
export default {"triggerStyles":"column_triggerStyles__DTy6v","triggerChildren":"column_triggerChildren__-p+xh","ruleNameTrigger":"column_ruleNameTrigger__g4trI"};